module.exports = __webpack_public_path__ + "img/zhaocha_des_4.1ac4b440.jpg";